var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"right":"","color":_vm.color},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('v-icon',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }